import { Emoji } from '../../util/a11y.jsx';
import { closingIn, formatDateTime } from '../../util/time.js';
// T270(6) — the deadline chip and its countdown formatter.
//
// This is the one component that reads the parent's 30s `nowTick`, and the
// reason that tick exists at all: without it a countdown reading "2h left"
// would still say so an hour later.
// T045 — Format ms-until-next-scan into a "Xh Ym" countdown string.
// Returns "now" when the count is sub-minute (cron is about to fire).
export function formatCountdown(ms) {
  if (!Number.isFinite(ms) || ms <= 0) return 'now';
  const totalMin = Math.floor(ms / 60000);
  const h = Math.floor(totalMin / 60);
  const m = totalMin % 60;
  if (h === 0) return `${m}m`;
  if (h < 24) return `${h}h ${m}m`;
  const d = Math.floor(h / 24);
  return `${d}d ${h % 24}h`;
}

// T188 — application-deadline chip. Renders nothing unless the deadline is
// close enough to change a decision, so it never becomes permanent furniture.
// Colours come from the theme's semantic tokens (T134), not raw Tailwind, so it
// stays legible on all seven themes.
export default function ClosingChip({ date }) {
  const c = closingIn(date);
  if (!c) return null;
  const tone =
    c.tone === 'down'
      ? 'text-[var(--c-down)]'
      : c.tone === 'warn'
        ? 'text-[var(--c-warn)]'
        : 'text-slate-400';
  return (
    <span className={`${tone} font-medium`} title={`Application deadline: ${formatDateTime(date)}`}>
      {' · '}
      {/* Decorative: the meaning is already in the adjacent label text. */}
      <Emoji>{c.expired ? '⛔' : '⏳'}</Emoji>{' '}
      {c.label}
    </span>
  );
}
